import { EditorSubType } from '@wix/editor-platform-sdk-types';

import { resolveEditorComponent } from '../../../resolveEditorComponent';
import type { TextLobbyData } from '../../../text/hooks/useTextLobbyData';

export type TextPreviewProps = TextLobbyData & {
  disabled?: boolean;
};

export default resolveEditorComponent({
  default: () => import('./variants/DefaultTextPreview'),
  overrides: {
    [EditorSubType.Studio2]: () => import('./variants/Studio2TextPreview'),
  },
});
